import { makeStyles } from "@mui/styles";
import theme from "mui/theme";

export const paragraphStyles = makeStyles(() => ({
  paragraph: {
    color: theme.palette.primary.dark,
    marginBottom: "20px !important",
  },
}));
